import { IContractCapsule } from 'entities'

export abstract class AbstractCapsuleFactory {
  abstract create(...params: unknown[]): Promise<IContractCapsule>
}
